import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Typography from '../../../../UniformComponents/Typography'

const VerbatimChartSlot = ({ store, position }) => {
    const slide = store.activeSlide
    const question = slide.question.get(position)

    const handleRemoveQuestion = () => {
        store.trackChartDeleted(question)
        store.handleCloseSideControls()
        store.activeSlide.removeQuestion(position)
    }

    if (!question) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 5 }} onClick={store.handleAddQuestion}>
                <div className="pp-add-slide">
                    <i className="fas fa-plus" />
                </div>

                <Typography>{i18n.t('q_editor_title_add')}</Typography>
            </div>
        )
    }

    return (
        <div className="pp-verbatim-chart-slot-container">
            <div className="pp-slide-controls">
                <div className="pp-slide-edit" onClick={() => store.handleEditChart(position)}>
                    <i className="fas fa-pen-to-square" />
                </div>

                <div className="pp-slide-delete" onClick={handleRemoveQuestion}>
                    <i className="fas fa-trash" />
                </div>
            </div>

            <div className="pp-verbatim-chart-slot-section-container">
                {[0, 1, 2].map((i) => (
                    <div className="pp-verbatim-chart-slot-option-container">
                        <div className="pp-verbatim-chart-slot-option">
                            <Typography style={{ display: 'flex', justifyContent: 'space-between' }} type="b">
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                    <span style={{color: 'white'}}>{question.chosenCategories.get(i)?.category || 'Add category'}</span>

                                    {question.chosenCategories.get(i) && (
                                        <Typography type="tiny" color="white" style={{ fontStyle: 'italic' }}>Auto commentary text</Typography>
                                    )}
                                </div>

                                {question.chosenCategories.get(i) && (
                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#0DAAC9', borderRadius: 6, color: 'white', width: 50, height: 50, flexShrink: 0 }}>{Math.round(question.chosenCategories.get(i)?.pct || 0)}%</span>
                                )}

                                {question.chosenCategories.get(i) && (
                                    <div className="pp-slide-controls" onClick={() => store.handleOpenVerbatimSettingsModal(i, true)}>
                                        <div className="pp-slide-edit">
                                            <i className="fas fa-pen-to-square" />
                                        </div>
                                    </div>
                                )}
                            </Typography>

                            <div className="pp-verbatim-chart-slot-option-comments">
                                <div className="pp-verbatim-chart-slot-option-comment">
                                    <Typography type="tiny-b" color="white">
                                        {question.chosenCategories.get(i)?.labels[0] || ''}
                                    </Typography>
                                </div>

                                <div className="pp-verbatim-chart-slot-option-comment">
                                    <Typography type="tiny-b" color="white">
                                        {question.chosenCategories.get(i)?.labels[1] || ''}
                                    </Typography>
                                </div>

                                <div className="pp-verbatim-chart-slot-option-comment">
                                    <Typography type="tiny-b" color="white">
                                        {question.chosenCategories.get(i)?.labels[2] || ''}
                                    </Typography>
                                </div>
                            </div>

                            {!question.chosenCategories.get(i) ? (
                                <div
                                    className="pp-verbatim-chart-slot-add-background"
                                    onClick={() => store.handleOpenVerbatimSettingsModal(i)}
                                >
                                    <div className="pp-verbatim-chart-slot-add-icon">
                                        <i className="fal fa-plus" />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default observer(VerbatimChartSlot)
